import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import StockMovementsTable from "@/components/inventory/stock-movements-table";

const movementsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  movementType: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/inventory/movements",
)({
  validateSearch: movementsSearchSchema,
  component: MovementsPage,
});

function MovementsPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "stock_movements", actions: ["read"] }]}>
      
    <div className="space-y-4">
      <StockMovementsTable
        currentPage={searchParams.page}
        basePath="/inventory/movements"
        searchParams={searchParams}
      />
    </div>
  
    </RouteGuardPermissions>
  );
}
